import { render, staticRenderFns } from "./no-results.vue?vue&type=template&id=bdcc389c&scoped=true&"
import script from "./no-results.vue?vue&type=script&lang=js&"
export * from "./no-results.vue?vue&type=script&lang=js&"
import style0 from "./no-results.vue?vue&type=style&index=0&id=bdcc389c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc389c",
  null
  
)

export default component.exports